export default {
  /**0代表rmb 人民币 */
  0: "¥",
  /**1代表usd 美元 */
  1: "$",
  /**2代表eur 欧元 */
  2: "€",
  /**3代表thd 泰铢 */
  3: "฿",
  /**4代表jpy 日元 */
  4: "￥",
  /** 5代表GBP英镑 */
  5: "£",
  /** 6代表CAD加币 */
  6: "C$",
};

export const MonetaryUnitEnum = {
  /**0代表rmb 人民币 */
  RMB: "¥",
  /**1代表usd 美元 */
  USD: "$",
  /**2代表eur 欧元 */
  EUR: "€",
  /**3代表thd 泰铢 */
  THD: "฿",
  /**4代表jpy 日元 */
  JPY: "￥",
  /** 5代表GBP英镑 */
  GBP: "£",
  /** 6代表CAD加币 */
  CAD: "C$",
};

export const currencyCodeMap = {
  0: "CNY",
  1: "USD",
  2: "EUR",
  3: "THB",
  4: "JPY",
  5: "GBP",
  6: "CAD",
};

export const currencyNameMap = {
  "CNY" : 0,
  "USD": 1,
  "EUR": 2,
  "THB": 3,
  "JPY": 4,
  "GBP": 5,
  "CAD": 6,
};
